import { useState } from "react";

const DEFAULT_DATA = {
  scans: [
    { id: "bs3", date: "2026-03-28", height: 178, weight: 82.4, bmi: 26.0, bodyFat: 18.2, muscleMass: 35.1, visceralFat: 8, bodyWater: 55.3, skeletalMuscle: 32.8, boneMass: 3.2, bmr: 1820, whr: 0.87, protein: 17.2, subcutFat: 145, fatFree: 67.4, bodyAge: 29, obesity: 12, desirableWt: 76, spO2: 98, bpSys: 118, bpDia: 76, hr: 62, lungCap: 4.2, balance: 82, vision: 1.0, reaction: 285,
      segmental: { leftArm: { muscle: 3.2, fat: 14 }, rightArm: { muscle: 3.4, fat: 13 }, trunk: { muscle: 28.1, fat: 18 }, leftLeg: { muscle: 9.8, fat: 16 }, rightLeg: { muscle: 9.9, fat: 15 } },
      posture: { shoulders: "normal", xoLegs: "normal", hunchback: "mild", pelvicTilt: "normal" },
      exercise: { caloriesHr: 580, targetBF: 15, estPeriod: { en: "12 weeks", es: "12 semanas" }, program: { en: "Strength + HIIT 4x/week", es: "Fuerza + HIIT 4x/semana" } } },
    { id: "bs2", date: "2026-02-28", height: 178, weight: 84.1, bmi: 26.5, bodyFat: 19.8, muscleMass: 34.2, visceralFat: 9, bodyWater: 54.1, skeletalMuscle: 31.9, boneMass: 3.2, bmr: 1790, whr: 0.89, protein: 16.8, subcutFat: 158, fatFree: 66.2, bodyAge: 31, obesity: 15, desirableWt: 76, spO2: 97, bpSys: 122, bpDia: 78, hr: 65, lungCap: 4.0, balance: 78, vision: 1.0, reaction: 310,
      segmental: { leftArm: { muscle: 3.0, fat: 16 }, rightArm: { muscle: 3.2, fat: 15 }, trunk: { muscle: 27.2, fat: 20 }, leftLeg: { muscle: 9.4, fat: 18 }, rightLeg: { muscle: 9.5, fat: 17 } },
      posture: { shoulders: "normal", xoLegs: "normal", hunchback: "mild", pelvicTilt: "mild" },
      exercise: { caloriesHr: 540, targetBF: 16, estPeriod: { en: "16 weeks", es: "16 semanas" }, program: { en: "Strength 3x + Cardio 2x/week", es: "Fuerza 3x + Cardio 2x/semana" } } },
    { id: "bs1", date: "2026-01-15", height: 178, weight: 86.3, bmi: 27.2, bodyFat: 22.1, muscleMass: 33.0, visceralFat: 10, bodyWater: 52.8, skeletalMuscle: 30.6, boneMass: 3.1, bmr: 1760, whr: 0.91, protein: 16.2, subcutFat: 172, fatFree: 64.8, bodyAge: 34, obesity: 19, desirableWt: 76, spO2: 96, bpSys: 128, bpDia: 82, hr: 70, lungCap: 3.8, balance: 72, vision: 0.9, reaction: 340,
      segmental: { leftArm: { muscle: 2.8, fat: 18 }, rightArm: { muscle: 3.0, fat: 17 }, trunk: { muscle: 26.0, fat: 23 }, leftLeg: { muscle: 9.0, fat: 20 }, rightLeg: { muscle: 9.1, fat: 19 } },
      posture: { shoulders: "mild", xoLegs: "normal", hunchback: "moderate", pelvicTilt: "mild" },
      exercise: { caloriesHr: 490, targetBF: 18, estPeriod: { en: "24 weeks", es: "24 semanas" }, program: { en: "Walking + Light weights 3x/week", es: "Caminata + Pesas ligeras 3x/semana" } } },
  ],
};

/** Bundles every piece of state used by the BodyScan route. */
export function useBodyScan() {
  const [bodyScanData, setBodyScanData] = useState(DEFAULT_DATA);
  const [selectedScan, setSelectedScan] = useState(0);
  const [bsTab, setBsTab] = useState<"overview" | "compare">("overview");
  const [compA, setCompA] = useState(0);
  const [compB, setCompB] = useState(
    DEFAULT_DATA.scans.length > 1 ? DEFAULT_DATA.scans.length - 1 : 0
  );
  const [bodyGoals, setBodyGoals] = useState<{
    bodyFat: number;
    muscleMass: number;
    weight: number;
  } | null>(null);
  const [editingGoals, setEditingGoals] = useState(false);
  const [goalDraft, setGoalDraft] = useState({ bodyFat: "", muscleMass: "", weight: "" });

  return {
    bodyScanData, setBodyScanData,
    selectedScan, setSelectedScan,
    bsTab, setBsTab,
    compA, setCompA,
    compB, setCompB,
    bodyGoals, setBodyGoals,
    editingGoals, setEditingGoals,
    goalDraft, setGoalDraft,
  };
}